import { motion, HTMLMotionProps } from 'framer-motion'
import { ForwardedRef, forwardRef } from 'react'

/**
 * framer-motion motion.div 래퍼
 * onUpdate={() => {}} 기본 적용 — framer-motion v14 깜빡임 이슈 대응
 * @see https://github.com/framer/motion/issues/XXXX
 */
const MotionDiv = forwardRef((props: HTMLMotionProps<'div'>, ref: ForwardedRef<HTMLDivElement>) => {
  return <motion.div ref={ref} onUpdate={() => {}} {...props} />
})

MotionDiv.displayName = 'MotionDiv'

export { MotionDiv }
